










































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'SidePanel'
})
export default class SidePanel extends Vue {
  @Prop({ default: false })
  visible!: boolean;

  @Prop({ default: 'Details' })
  title!: string;

  @Prop({ default: '500px' })
  width!: string;
}
